import { appEnv } from "src/const/appEnv";

const latourBaseUrl = (() => {
  switch (appEnv) {
    case "production":
      return "https://curon.co";
    case "demo":
      return "https://demo-j0fcg3jw4hdd5gy8.stg.curon.co";
    case "develop":
      return "https://stg8.stg.curon.co";
    case "local":
      return "http://localhost:4201";
    case "staging0":
      return "https://stg0.stg.curon.co";
    case "staging1":
      return "https://stg1.stg.curon.co";
    case "staging2":
      return "https://stg2.stg.curon.co";
    case "staging3":
      return "https://stg3.stg.curon.co";
    case "staging6":
      return "https://stg6.stg.curon.co";
    case "staging8":
      return "https://stg8.stg.curon.co";
    default:
      const _exhaustiveCheck: never = appEnv;

      throw new Error(`unreachable appEnv: ${_exhaustiveCheck}`);
  }
})();

export const MICIN_TOP = "https://micin.jp/";
export const PRIVACY_POLICY = `${latourBaseUrl}/static/app/privacy.html`;
export const MICIN_PRIVACY_POLICY = "https://micin.jp/privacy";
export const TERMS = "https://id.curon.co/terms.html";
export const EXTERNAL_TRANSMISSION = `${latourBaseUrl}/assets/external_transmission.pdf`;
export const SECURITY = "https://micin.jp/security";
export const CONTACT = "https://app.curon.co/contact";
export const FAQ =
  "https://micin.my.site.com/FAQforPatients/s/topic/0TO5i000000HyPBGA0/クロンスマートパスに関するfaq";

const yapBaseUrl = (() => {
  switch (appEnv) {
    case "production":
      return "https://pha.curon.co";
    case "demo":
      return "https://demo-j0fcg3jw4hdd5gy8-pha.stg.curon.co";
    case "develop":
      return "https://stg8-pha.stg.curon.co";
    case "local":
      return "http://localhost:4002";
    case "staging0":
      return "https://stg0-pha.stg.curon.co";
    case "staging1":
      return "https://stg1-pha.stg.curon.co";
    case "staging2":
      return "https://stg2-pha.stg.curon.co";
    case "staging3":
      return "https://stg3-pha.stg.curon.co";
    case "staging6":
      return "https://stg6-pha.stg.curon.co";
    case "staging8":
      return "https://stg8-pha.stg.curon.co";
    default:
      const _exhaustiveCheck: never = appEnv;

      throw new Error(`unreachable appEnv: ${_exhaustiveCheck}`);
  }
})();

export const YAP_BASE = yapBaseUrl;

export const YAP_SEARCH = `${yapBaseUrl}/search?utm_source=non-paid_offline&utm_medium=banner&utm_campaign=momo_net`;

export const yapPharmacyVisitDetailUrl = (pharmacyVisitId: string): string => {
  return `${yapBaseUrl}/telepharmacy/${pharmacyVisitId}`;
};

const koalaBaseUrl = (() => {
  switch (appEnv) {
    case "production":
      return "https://app.curon.co";
    case "demo":
      return "https://stg7-sbek23vrx2h1nv0x-app.stg.curon.co";
    case "develop":
      return "https://stg8-jh2uybose3vuiecu-app.stg.curon.co";
    case "local":
      return "http://localhost:11080";
    case "staging0":
      return "https://stg0-lpytcxsa0865xy0r-app.stg.curon.co";
    case "staging1":
      return "https://stg1-px2qrxad74avtihr-app.stg.curon.co";
    case "staging2":
      return "https://stg2-5iwlqb7ervy1l7dm-app.stg.curon.co";
    case "staging3":
      return "https://stg3-xzr303sallno5lfp-app.stg.curon.co";
    case "staging6":
      return "https://stg6-pyhbgucqoyp1cmt9-app.stg.curon.co";
    case "staging8":
      return "https://stg8-jh2uybose3vuiecu-app.stg.curon.co";
    default:
      const _exhaustiveCheck: never = appEnv;

      throw new Error(`unreachable appEnv: ${_exhaustiveCheck}`);
  }
})();

export const KOALA_BASE = koalaBaseUrl;
